<template>
  <div :class="elementClass" @click="elOnClick()">
    <input
      ref="checkbox"
      :checked="value"
      @click="thumbOnClick"
      @change="$emit('input', $event.target.checked)"
      type="checkbox"
      :disabled="disabled"
      :name="name"
    />
    <div ref="ripple" class="mad-checkbox-ripple"></div>
    <mad-icon class="mad-checkbox-uncheck" name="mdiCheckboxBlankOutline"></mad-icon>
    <mad-icon class="mad-checkbox-check" name="mdiCheckboxMarked"></mad-icon>
    <div class="mad-checkbox-label" v-if="label">{{ label }}</div>
  </div>
</template>

<script>
import { checkboxClass } from "../prefix";
import Helper from "../helper";
export default {
  props: {
    value: {},
    disabled: {
      default: false,
    },
    IsLabel: {
      default: false,
    },
    name: {
      default: "",
    },
    checkIcon: {
      default: "check_box",
    },
    uncheckIcon: {
      default: "check_box_outline_blank",
    },
    label: {
      default: "",
    },
    noOutline: {
      default: false,
    },
  },
  computed: {
    elementClass() {
      return [checkboxClass, { disabled: this.disabled, noOutline: this.noOutline, IsLabel: this.IsLabel }];
    },
  },
  methods: {
    elOnClick() {
      this.$refs.checkbox.click();
    },
    thumbOnClick() {
      this.$emit("click");
      Helper.addClass(this.$refs.ripple, "active");
      setTimeout(() => {
        Helper.removeClass(this.$refs.ripple, "active");
      }, 300);
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-checkbox";

@mixin generateCreateCheckbox($className) {
  @for $i from 1 to length($colorNameSet) {
    @include createCheckbox($className, nth($colorNameSet, $i), nth($colorCodeSet, $i));
  }
}

$colorCodeSet: $theme-primary, $theme-accent, $color-red, $color-pink, $color-purple, $color-deep-purple, $color-indigo, $color-blue,
  $color-light-blue, $color-cyan, $color-teal, $color-green, $color-light-green, $color-lime, $color-yellow, $color-amber, $color-orange,
  $color-deep-orange, $color-brown, $color-blue-grey;
$colorNameSet: "primary", "accent", "red", "pink", "purple", "deep-purple", "indigo", "blue", "light-blue", "cyan", "teal", "green", "light-green",
  "lime", "yellow", "amber", "orange", "deep-orange", "brown", "blue-grey";
@mixin createCheckbox($className, $colorName, $colorCode) {
  &.#{$colorName} {
    #{$className}-check {
      color: $colorCode;

      svg > path {
        fill: $colorCode !important;
      }
    }
    input[type="checkbox"] {
      &:checked ~ #{$className}-ripple {
        background-color: rgba($colorCode, 0.2);
      }
    }
  }
}

#{$element} {
  min-height: 44px;
  width: 100%;
  cursor: pointer;
  float: left;
  padding: 0 16px;
  border-radius: 2px;
  border: 1px solid transparent;
  #{$element}-check,
  #{$element}-uncheck {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 10px;
    left: 16px;
    z-index: 2;
  }
  #{$element}-check {
    color: $theme-primary;
    @include transform(scale(0));
    @include transition((all 0.2s $animation-standard-curve-timing-function, opacity 0.25s $animation-standard-curve-timing-function));
    opacity: 0;

    svg path {
      fill: $theme-primary !important;
    }
  }
  #{$element}-uncheck {
    color: rgba($color-black, 0.54);
    @include transition((opacity 0.25s $animation-standard-curve-timing-function));

    svg path {
      fill: rgba($color-black, 0.54) !important;
    }
  }
  #{$element}-ripple {
    width: 44px;
    height: 44px;
    @include border-radius(50%);
    background: rgba($color-black, 0.1);
    top: 0px;
    left: 6px;
    position: absolute;
    @include transition(all 0.2s $animation-standard-curve-timing-function);
    opacity: 0;
    &.active {
      opacity: 1;
    }
  }

  #{$element}-label {
    color: $color-grey-800;
    font-size: 12px;
    top: 0px;
    left: 60px;
    min-height: 44px;
    line-height: 36px;
    padding: 4px 0;
    width: calc(100% - 44px);
  }
  input[type="checkbox"] {
    display: none;
    &:checked ~ #{$element}-check {
      @include transform(scale(1));
      opacity: 1;
    }
    &:checked ~ #{$element}-uncheck {
      opacity: 0;
    }
    &:checked ~ #{$element}-ripple {
      background-color: rgba($theme-primary, 0.2);
    }
  }
  input[type="checkbox"]:disabled,
  input[type="checkbox"]:checked:disabled {
    pointer-events: none;
    & ~ #{$element}-check,
    & ~ #{$element}-uncheck {
      color: rgba($color-black, 0.26);
      svg path {
        fill: rgba($color-black, 0.26) !important;
      }
    }

    #{$element}-label {
      color: rgba($color-black, 0.26);
    }
  }

  &.disabled {
    pointer-events: none;
    #{$element}-check,
    #{$element}-uncheck {
      color: rgba($color-black, 0.26);
      svg path {
        fill: rgba($color-black, 0.26) !important;
      }
    }

    #{$element}-label {
      color: rgba($color-black, 0.26);
      svg path {
        fill: rgba($color-black, 0.26) !important;
      }
    }
  }

  &.IsLabel {
    pointer-events: none;
    #{$element}-check,
    #{$element}-uncheck {
      color: rgba($color-black, 0.26);
      svg path {
        fill: rgba($color-black, 0.26) !important;
      }
    }

    #{$element}-label {
      color: rgba($color-black, 0.26);
      svg path {
        fill: rgba($color-black, 0.26) !important;
      }
    }

    #{$element}-label {
      color: rgba($color-black, 0.9);
    }
  }

  &.invert {
    #{$element}-label {
      color: $color-white;
    }

    #{$element}-check {
      color: $color-white;
      svg path {
        fill: $color-white !important;
      }
    }
    #{$element}-uncheck {
      color: rgba($color-white, 0.54);
      svg path {
        fill: rgba($color-white, 0.54) !important;
      }
    }
  }

  &:hover {
    border: 1px solid $color-grey-200;
  }

  &.noOutline {
    border: 1px solid transparent;
  }
  @include generateCreateCheckbox($element);
}
</style>
